import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class NewPartnerWindowFormService {
  private form = new FormGroup({
    partner: new FormGroup({}),
    users: new FormGroup({}),
    addressess: new FormGroup({}),
  });

  get partnerForm(): FormGroup {
    return this.form.get('partner') as FormGroup;
  }
  get usersForm(): FormGroup {
    return this.form.get('users') as FormGroup;
  }
  get addressesForm(): FormGroup {
    return this.form.get('addressess') as FormGroup;
  }

  get allForms(): object {
    return this.form.getRawValue();
  }
  setForm = (form: FormGroup) => {
    this.form = form;
  };
  getForm = (): FormGroup => {
    return this.form;
  };
  get generateForm() {
    return new FormGroup({
      partner: new FormGroup({}),
      users: new FormGroup({}),
      addressess: new FormGroup({}),
    });
  }
}
